module.exports = __webpack_public_path__ + "img/section3-star.cb7d5640.svg";